import { Expose } from 'class-transformer';
import { Model } from './Model';
import type { IdeaWithVersion } from './Idea';

export enum FloorSlotStatus {
	Vacant   = 'VACANT',
	Active   = 'ACTIVE',
	Reserved = 'RESERVED',
}

export enum ConsensusOutcome {
	Consensus    = 1,
	NoConsensus  = 2,
	QuorumFailed = 3,
}

export class FloorSlot extends Model {
	private _organizationId: string | null = null;
	@Expose()
	set organizationId(v: string | null) { this._organizationId = v; }
	get organizationId(): string | null { return this._organizationId; }

	private _slotNumber = 1;
	@Expose()
	set slotNumber(v: number) { this._slotNumber = v; }
	get slotNumber(): number { return this._slotNumber; }

	private _status: FloorSlotStatus = FloorSlotStatus.Vacant;
	@Expose()
	set status(v: FloorSlotStatus) { this._status = v; }
	get status(): FloorSlotStatus { return this._status; }

	private _ideaId: string | null = null;
	@Expose()
	set ideaId(v: string | null) { this._ideaId = v; }
	get ideaId(): string | null { return this._ideaId; }

	private _assignedAt: Date | null = null;
	@Expose()
	set assignedAt(v: Date | string | null) { this._assignedAt = v ? new Date(v as string) : null; }
	get assignedAt(): Date | null { return this._assignedAt; }

	private _isDeleted = false;
	@Expose()
	set isDeleted(v: boolean) { this._isDeleted = v; }
	get isDeleted(): boolean { return this._isDeleted; }

	constructor(json: any = null) {
		super(json);
		if (json) this.originalJson = json;
	}
}

export interface FloorSlotRow {
	slot: FloorSlot;
	idea: IdeaWithVersion['idea'] | null;
	version: IdeaWithVersion['version'] | null;
}

export interface VoteTally {
	supportCount: number;
	supportWithReservationsCount: number;
	doNotSupportCount: number;
	totalVotes: number;
}

export interface ActiveFloorSlotRow extends FloorSlotRow {
	myVote: { id: string; choice: number; } | null;
	tally: VoteTally;
}
